import React, { useEffect, useState } from "react";
import "./profiledetails.scss";
import { profileimg } from "../../assets/images";
import {
  callicon,
  editicon,
  messageicon,
  profileicon,
} from "../../assets/icons";
import useUser from "../../hooks/useUser";
import PhoneInput from "react-phone-input-2";
import { useMutation } from "@tanstack/react-query";
import { AuthService, UserService } from "../../services";
import useSnackbar from "../../hooks/useSnackbar";

import { Modal, Spinner } from "react-bootstrap";
import ButtonLoader, { ButtonLoading } from "../../component/buttonLoader";
import OTPInput from "react-otp-input";
import { Link } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import { FaArrowRightLong } from "react-icons/fa6";
import HttpService, { TOKEN } from "../../services/http";
import moment from "moment";
import { joiResolver } from "@hookform/resolvers/joi";
import { set, useForm } from "react-hook-form";
import {
  createProfileValidation,
  updateProfileValidation,
} from "../../validations";
import DatePicker from "react-datepicker";
import { bloodGroups } from "../../utils/common";
import Select from "react-select";
import { decryptData, generateFormDataPayload } from "../../utils/helper";

const ProfileDetails = () => {
  const { user, setUser } = useUser();
  const isMobileVerified = user?.isMobileVerified;
  const [isTempDisabled, setIsTempDisabled] = useState(false);
  // const [profileImage, setProfileImage] = useState(null);
  const isEmailVerified = user?.isEmailVerified;
  const { httpRequest, httpFormRequest } = HttpService();
  const { sendOtp, verifyOtp } = AuthService();
  const { updateUser } = UserService();
  const [seconds, setSeconds] = useState(60);
  const [otp, setOtp] = useState("");
  const [modalShow, setModalShow] = useState({
    isOpen: false,
    type: "EMAIL",
  });
  const { snackbar } = useSnackbar();
  const [state, setState] = useState({
    countryCode: user?.countryCode || "",
    mobile: user?.mobile || "",
    email: "",
    isEmailVerified: isEmailVerified || false,
    isMobileVerified: isMobileVerified || false,
  });
  const {
    register,
    getValues,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(updateProfileValidation),
    defaultValues: {
      profile: "",
      name: "",
      emergencyContact: "",
      dob: "",
      bloodGroup: "",
      height: "",
      weight: "",
      address: "",
    },
  });

  const emergencyContact = watch("emergencyContact");
  const dob = watch("dob");
  const bloodGroup = watch("bloodGroup");
  const profileImage = watch("profile");

  useEffect(() => {
    setValue("profile", user?.profile);
    setValue("name", user?.name);
    setValue("emergencyContact", user?.emergencyContact);
    setValue("dob", user?.dob);
    setValue("bloodGroup", user?.bloodGroup);
    setValue("height", user?.height);
    setValue("weight", user?.weight);
    setValue("address", user?.address);
  }, []);

  useEffect(() => {
    if (seconds < 60) {
      return;
    }

    const intervalId = setInterval(() => {
      setSeconds((prevTime) => {
        if (prevTime === 0) {
          clearInterval(intervalId);
          return 0;
        }

        return prevTime - 1;
      });
    }, 1000);
  }, [seconds]);

  const updateUserMutation = useMutation({
    mutationFn: (data) => {
      // Trigger 10-second disable
      setIsTempDisabled(true);
      setTimeout(() => setIsTempDisabled(false), 5000);
      return updateUser({
        ...user,
        ...data,
        dob: data.dob
          ? moment(data.dob).format("YYYY-MM-DD")
          : moment(user.dob).format("YYYY-MM-DD"),
        token: localStorage.getItem("hollypills_token"),
      });
    },
    onSuccess: (data) => {
      if (data?.data?.user) {
        setUser(data?.data?.user);
      }
      snackbar(data?.message || "", "info");
    },
    onError: (err) => {
      snackbar(err.data.message || "");
    },
  });

  const sendOtpMutation = useMutation({
    mutationFn: (data) => {
      return sendOtp({ ...data, type: "otp" });
    },
    onSuccess: (data) => {
      setSeconds(60);
      snackbar(data?.message || "", "info");
    },
    onError: (err) => {
      snackbar(err.data.message || "");
    },
  });

  const verifyOtpMutation = useMutation({
    mutationFn: (data) => {
      if (otp.length !== 6) {
        snackbar("Please enter valid otp code" || "");
        return null;
      }

      return verifyOtp(data);
    },
    onSuccess: (data) => {
      if (data) {
        if (modalShow.type === "MOBILE") {
          updateUserMutation.mutate({
            isMobileVerified: true,
            mobile: state.mobile,
            countryCode: state.countryCode,
          });
        } else {
          updateUserMutation.mutate({
            isEmailVerified: true,
            email: state.email,
          });
        }
        setModalShow({
          isOpen: false,
          type: "EMAIL",
        });
      }
    },
    onError: (err) => {
      snackbar(err.data.message || "");
    },
  });

  const uploadImage = useMutation({
    mutationFn: (file) => {
      const formData = new FormData();
      formData.append("image", file.target.files[0]);

      return httpFormRequest("PUT", "user/v1/profile/updateprofile", generateFormDataPayload({
        ...user,
        token: localStorage.getItem("hollypills_token"),
        ...(user.dob && { dob: moment(user.dob).format("YYYY-MM-DD") }),
        profile: file.target.files[0]
      }, "profile"));
    },
    onSuccess: (data) => {
      data = decryptData(data);
      if (data?.data?.user) {
        setUser(data?.data?.user);
        setValue("profile", data?.data?.user?.profile);
      }
      snackbar(data?.message || "", "info");
    },
    onError: (err) => {
      snackbar(err.data.message || "");
    },
  });

  const image = profileImage ? profileImage : profileimg

  return (
    <div className="wrapper_profile_details">
      <div className="land_tittle">
        <h2 className="title">Hello {user.name},</h2>
      </div>
      <div className="wrapper_details">
        <div className="container">
          <div className="wrap_details">
            <p className="details">Details</p>
            <div className="wrap_img_profile">
              <div className="wrap_left">
                <div className="wrap_img">
                  <figure>
                    {
                      uploadImage.isPending
                        ?
                        <Spinner animation="border" role="status" variant="primary"></Spinner>
                        :
                        <img
                          src={image}
                          alt="spiner-image"
                        />
                    }
                    <input
                      type="file"
                      id="file"
                      onChange={uploadImage.mutate}
                    />
                    <label htmlFor="file">
                      <img src={editicon} alt="edit-icon" />
                    </label>
                  </figure>
                </div>
                {/* <img src={user?.profile ? user?.profile : profileimg} alt="" /> */}
              </div>

              <div className="wrap_right">
                <form onSubmit={handleSubmit(updateUserMutation.mutate)}>
                  <ul>
                    {/* <li>
                    <img src={profileicon} alt="" />
                    {user.name}
                  </li> */}
                    <li>
                      <div className="form_field icon_set">
                        <label className="label" htmlFor="">
                          Name
                        </label>
                        <input
                          className="input form-control"
                          type="text"
                          placeholder="Enter your Name"
                          {...register("name")}
                        />
                        {errors.name?.message && (
                          <span className="error">{errors.name?.message}</span>
                        )}
                      </div>
                    </li>
                    <li>

                      <div className="form_field icon_set">
                        <label className="label" htmlFor="">
                          Mobile Number
                        </label>
                        <PhoneInput
                          placeholder="Enter Number"
                          country={"in"}
                          disabled={isMobileVerified}
                          value={`${state.countryCode}${state.mobile}`}
                          onChange={(fullNumber, dialCodeDetail) => {
                            const mobile = fullNumber.replace(
                              `${dialCodeDetail?.dialCode}`,
                              ""
                            );
                            const countryCode = dialCodeDetail?.dialCode;
                            setState((prev) => ({
                              ...prev,
                              countryCode,
                              mobile,
                            }));
                          }}
                        />
                        <span
                          className={`verify ${isMobileVerified && "verify_sucess"
                            }`}
                          onClick={() => {
                            if (
                              state.mobile.length > 4 &&
                              !isMobileVerified
                            ) {
                              setModalShow({
                                isOpen: true,
                                type: "MOBILE",
                              });
                              sendOtpMutation.mutate({
                                mobile: state.mobile,
                                countryCode: state.countryCode,
                              });
                            }
                          }}
                        >
                          {isMobileVerified ? "Verified" : "Verify"}
                        </span>
                      </div>
                    </li>
                    <li>
                      <div className="form_field icon_set">
                        <label className="label" htmlFor="">
                          Email
                        </label>
                        <input
                          style={{ backgroundColor: "transparent" }}
                          className="input form-control"
                          placeholder="Enter your Email"
                          value={user?.email}
                          disabled={isEmailVerified}
                          onChange={(e) =>
                            setState((prev) => ({
                              ...prev,
                              email: e.target.value,
                            }))
                          }
                        />
                        <span
                          className={`verify ${isEmailVerified && "verify_sucess"
                            }`}
                          onClick={() => {
                            if (state.email.length > 4 && !isEmailVerified) {
                              setModalShow({
                                isOpen: true,
                                type: "EMAIL",
                              });
                              sendOtpMutation.mutate({ email: state.email });
                            }
                          }}
                        >
                          {isEmailVerified ? "Verified" : "Verify"}
                        </span>
                      </div>
                    </li>
                    <li>
                      <div className="form_field">
                        <label className="label" htmlFor="">
                          Emergency Mobile Number
                        </label>
                        <PhoneInput
                          placeholder="Enter Number"
                          country={"in"}
                          value={emergencyContact}
                          onChange={(fullNumber, dialCodeDetail) => {
                            const mobile = fullNumber.replace(
                              `${dialCodeDetail?.dialCode}`,
                              ""
                            );
                            const countryCode = dialCodeDetail?.dialCode;
                            setValue(
                              "emergencyContact",
                              `${countryCode}${mobile}`
                            );
                          }}
                        />
                        {errors.emergencyContact?.message && (
                          <span className="error">
                            {errors.emergencyContact?.message}
                          </span>
                        )}
                      </div>
                    </li>
                    <li>
                      <div className="form_field icon_set">
                        <label
                          style={{ display: "block" }}
                          className="label"
                          htmlFor=""
                        >
                          Date Of Birth
                        </label>
                        <DatePicker
                          selected={dob}
                          onChange={(date) => {
                            const dobDate = new Date(date).toISOString();
                            setValue("dob", dobDate);
                          }}
                          className="input form-control w-100"
                          placeholder="Select DOB"
                        />
                        {errors.dob?.message && (
                          <span className="error">{errors.dob?.message}</span>
                        )}
                      </div>
                    </li>
                    <li>
                      <div className="form_field icon_set">
                        <label className="label" htmlFor="">
                          Blood Group
                        </label>
                        <Select
                          className="cstm_select"
                          options={bloodGroups}
                          value={{ label: bloodGroup, value: bloodGroup }}
                          onChange={(e) => setValue("bloodGroup", e.label)}
                        />
                        {errors.bloodGroup?.message && (
                          <span className="error">
                            {errors.bloodGroup?.message}
                          </span>
                        )}
                      </div>
                    </li>

                    <li>
                      <div className="form_field icon_set">
                        <label className="label" htmlFor="">
                          Height (in cm)
                        </label>
                        <input
                          className="input form-control"
                          placeholder="Enter your Height"
                          {...register("height")}
                        />
                        <span>cm</span>
                        {errors.height?.message && (
                          <span className="error">
                            {errors.height?.message}
                          </span>
                        )}
                      </div>
                    </li>
                    <li>
                      <div className="form_field icon_set">
                        <label className="label" htmlFor="">
                          Weight (in kg)
                        </label>
                        <input
                          className="input form-control"
                          placeholder="Enter your Weight"
                          {...register("weight")}
                        />
                        <span>kg</span>
                        {errors.weight?.message && (
                          <span className="error">
                            {errors.weight?.message}
                          </span>
                        )}
                      </div>
                    </li>

                    <li>
                      <div className="form_field icon_set">
                        <label className="label" htmlFor="">
                          Address
                        </label>
                        <input
                          className="input form-control"
                          placeholder="Enter your Address"
                          {...register("address")}
                        />
                        {errors.address?.message && (
                          <span className="error">
                            {errors.address?.message}
                          </span>
                        )}
                      </div>
                    </li>

                    <li className="width_btn">
                      <ButtonLoading
                        text={<>Update</>}
                        className="login"
                        isLoading={updateUserMutation.isPending}
                        disabled={updateUserMutation.isPending || isTempDisabled}
                      />
                    </li>
                  </ul>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* otp verification */}
      <Modal
        className="cstm_modal"
        show={modalShow.isOpen}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Enter the OTP code <br /> sent to you
            <span
              onClick={() =>
                setModalShow({
                  isOpen: false,
                  type: "EMAIL",
                })
              }
            >
              <RxCross2 />
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Code sent to <Link to={""}>{``}</Link> unless you already have an
            account
          </p>
          <div className="otp_form" action="">
            <div className="form_field">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderInput={(props) => <input {...props} />}
              />
            </div>
            {seconds < 1 ? (
              <ButtonLoader
                text={"Resend OTP"}
                className="login"
                isLoading={sendOtpMutation.isPending}
                onClick={() => {
                  let payload = {};
                  if (modalShow.type === "EMAIL") {
                    payload = {
                      email: state.email,
                    };
                  } else {
                    payload = {
                      mobile: state.mobile,
                      countryCode: state.countryCode,
                    };
                  }
                  sendOtpMutation.mutate(payload);
                }}
              />
            ) : (
              <p>
                Resend OTP in <b>00:{seconds}</b> Seconds
              </p>
            )}
            <div className="btn_wrap_login">
              <ButtonLoader
                text={
                  <>
                    Verify <FaArrowRightLong />
                  </>
                }
                className="login"
                isLoading={verifyOtpMutation.isPending}
                onClick={() => {
                  let payload = {};
                  if (modalShow.type === "EMAIL") {
                    payload = {
                      email: state.email,
                      otp: otp,
                    };
                  } else {
                    payload = {
                      mobile: state.mobile,
                      countryCode: state.countryCode,
                      otp: otp,
                    };
                  }
                  verifyOtpMutation.mutate(payload);
                }}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProfileDetails;
